<template>
  <div>
    <el-row :span="24" :gutter="20" style="margin-bottom: 20px;">
      <el-col :span="12">
        <el-date-picker
          v-model="date"
          :clearable='false'
          format="d MMM yy"
          value-format="MM-dd-yyyy"
          type="date"
          placeholder="As At">
        </el-date-picker>
      </el-col>
      <el-col :span="12"></el-col>
    </el-row>

    <div class="data-hide">
      <el-table
        :data="tableData"
        border
        size="mini"
        style="width: 100%">
        <el-table-column
          label="DB Code"
          width="100">
        </el-table-column>
        <el-table-column
          label="Acc. No."
          width="100">
        </el-table-column>
        <el-table-column
          label="Tax Accounts">
        </el-table-column>
        <el-table-column
          label="Tax Code"
          header-align="center"
          width="100">
        </el-table-column>
        <el-table-column
          label="Rate %"
          header-align="center"
          width="100">
        </el-table-column>
        <el-table-column
          label="Report"
          header-align="center"
          width="100">
        </el-table-column>
        <el-table-column
          label="Ending Balances"
          header-align="center"
          width="300">
        </el-table-column>
        <el-table-column
          label="Set As"
          header-align="center"
          width="100">
        </el-table-column>
      </el-table>
    </div>

    <!-- сreditableWithHoldingTax -->
    <el-table
      :data="сreditableWithHoldingTax"
      :show-header="false"
      size="mini"
      :row-class-name="tableRowClassName"
      style="width: 100%">
      <el-table-column
        prop="dbcode"
        label="DB Code"
        width="100">
      </el-table-column>
      <el-table-column
        prop="accountno"
        label="Acc. No."
        width="100">
      </el-table-column>
      <el-table-column
        prop="taxaccounts"
        label="Tax Accounts">
      </el-table-column>
      <el-table-column
        prop="taxcode"
        align="center"
        label="Tax Code"
        width="100">
      </el-table-column>
      <el-table-column
        prop="taxrate"
        align="center"
        label="Rate %"
        width="100">
      </el-table-column>
      <el-table-column
        prop="report"
        align="center"
        label="Report"
        width="100">
      </el-table-column>
      <el-table-column
        prop="endingbalance"
        align="center"
        label="Ending Balances"
        width="300">
        <template slot-scope="scope">
          Amount: {{scope.row.endingbalance ? formatPrice(scope.row.endingbalance) : '0.00'}}
        </template>
      </el-table-column>
      <el-table-column
        prop="setas"
        align="center"
        label="Set As"
        width="100">
      </el-table-column>
    </el-table>

    <!-- сreditableWithHoldingTaxSub -->
    <el-table
      :data="сreditableWithHoldingTaxSub"
      :show-header="false"
      size="mini"
      style="width: 100%">
      <el-table-column
        prop="dbcode"
        label="DB Code"
        width="100">
      </el-table-column>
      <el-table-column
        prop="accountno"
        label="Acc. No."
        width="100">
      </el-table-column>
      <el-table-column
        prop="accountname"
        label="Tax Accounts">
      </el-table-column>
      <el-table-column
        prop="taxcode"
        align="center"
        label="Tax Code"
        width="100">
      </el-table-column>
      <el-table-column
        prop="taxrate"
        align="center"
        label="Rate %"
        width="100">
      </el-table-column>
      <el-table-column
        prop="report"
        align="center"
        label="Report"
        width="100">
      </el-table-column>
      <el-table-column
        prop="endingbalance"
        align="center"
        label="Ending Balances"
        width="300">
        <template slot-scope="scope">
          {{scope.row.endingbalance ? formatPrice(scope.row.endingbalance) : '0.00'}}
        </template>
      </el-table-column>
      <el-table-column
        prop="setas"
        align="center"
        label="Set As"
        width="100">
      </el-table-column>
    </el-table>

    <!-- withholdingTaxExpanded -->
    <el-table
      :data="withholdingTaxExpanded"
      :show-header="false"
      size="mini"
      :row-class-name="tableRowClassName"
      style="width: 100%">
      <el-table-column
        prop="dbcode"
        label="DB Code"
        width="100">
      </el-table-column>
      <el-table-column
        prop="accountno"
        label="Acc. No."
        width="100">
      </el-table-column>
      <el-table-column
        prop="taxaccounts"
        label="Tax Accounts">
      </el-table-column>
      <el-table-column
        prop="taxcode"
        align="center"
        label="Tax Code"
        width="100">
      </el-table-column>
      <el-table-column
        prop="taxrate"
        align="center"
        label="Rate %"
        width="100">
      </el-table-column>
      <el-table-column
        prop="report"
        align="center"
        label="Report"
        width="100">
      </el-table-column>
      <el-table-column
        prop="endingbalance"
        align="center"
        label="Ending Balances"
        width="300">
        <template slot-scope="scope">
          Amount: {{scope.row.endingbalance ? formatPrice(scope.row.endingbalance) : '0.00'}}
        </template>
      </el-table-column>
      <el-table-column
        prop="setas"
        align="center"
        label="Set As"
        width="100">
      </el-table-column>
    </el-table>

    <!-- withholdingTaxExpandedSub -->
    <el-table
      :data="withholdingTaxExpandedSub"
      :show-header="false"
      size="mini"
      style="width: 100%">
      <el-table-column
        prop="dbcode"
        label="DB Code"
        width="100">
      </el-table-column>
      <el-table-column
        prop="accountno"
        label="Acc. No."
        width="100">
      </el-table-column>
      <el-table-column
        prop="accountname"
        label="Tax Accounts">
      </el-table-column>
      <el-table-column
        prop="taxcode"
        align="center"
        label="Tax Code"
        width="100">
      </el-table-column>
      <el-table-column
        prop="taxrate"
        align="center"
        label="Rate %"
        width="100">
      </el-table-column>
      <el-table-column
        prop="report"
        align="center"
        label="Report"
        width="100">
      </el-table-column>
      <el-table-column
        prop="endingbalance"
        align="center"
        label="Ending Balances"
        width="300">
        <template slot-scope="scope">
          {{scope.row.endingbalance ? formatPrice(scope.row.endingbalance) : '0.00'}}
        </template>
      </el-table-column>
      <el-table-column
        prop="setas"
        align="center"
        label="Set As"
        width="100">
      </el-table-column>
    </el-table>

    <!-- withholdingTaxOnCompensation -->
    <el-table
      :data="withholdingTaxOnCompensation"
      :show-header="false"
      size="mini"
      :row-class-name="tableRowClassName"
      style="width: 100%">
      <el-table-column
        prop="dbcode"
        label="DB Code"
        width="100">
      </el-table-column>
      <el-table-column
        prop="accountno"
        label="Acc. No."
        width="100">
      </el-table-column>
      <el-table-column
        prop="taxaccounts"
        label="Tax Accounts">
      </el-table-column>
      <el-table-column
        prop="taxcode"
        align="center"
        label="Tax Code"
        width="100">
      </el-table-column>
      <el-table-column
        prop="taxrate"
        align="center"
        label="Rate %"
        width="100">
      </el-table-column>
      <el-table-column
        prop="report"
        align="center"
        label="Report"
        width="100">
      </el-table-column>
      <el-table-column
        prop="endingbalance"
        align="center"
        label="Ending Balances"
        width="300">
        <template slot-scope="scope">
          Amount: {{scope.row.endingbalance ? formatPrice(scope.row.endingbalance) : '0.00'}}
        </template>
      </el-table-column>
      <el-table-column
        prop="setas"
        align="center"
        label="Set As"
        width="100">
      </el-table-column>
    </el-table>

    <!-- withholdingTaxOnCompensationSub -->
    <el-table
      :data="withholdingTaxOnCompensationSub"
      :show-header="false"
      size="mini"
      style="width: 100%">
      <el-table-column
        prop="dbcode"
        label="DB Code"
        width="100">
      </el-table-column>
      <el-table-column
        prop="accountno"
        label="Acc. No."
        width="100">
      </el-table-column>
      <el-table-column
        prop="accountname"
        label="Tax Accounts">
      </el-table-column>
      <el-table-column
        prop="taxcode"
        align="center"
        label="Tax Code"
        width="100">
      </el-table-column>
      <el-table-column
        prop="taxrate"
        align="center"
        label="Rate %"
        width="100">
      </el-table-column>
      <el-table-column
        prop="report"
        align="center"
        label="Report"
        width="100">
      </el-table-column>
      <el-table-column
        prop="endingbalance"
        align="center"
        label="Ending Balances"
        width="300">
        <template slot-scope="scope">
          {{scope.row.endingbalance ? formatPrice(scope.row.endingbalance) : '0.00'}}
        </template>
      </el-table-column>
      <el-table-column
        prop="setas"
        align="center"
        label="Set As"
        width="100">
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
  import axios from 'axios'
  let moment = require('moment');
  export default {
    data() {
      return {
        date: moment().format("MM-DD-YYYY"),
        tableData: [],

        сreditableWithHoldingTaxSub: [],
        сreditableWithHoldingTax: [],
        withholdingTaxExpandedSub: [],
        withholdingTaxExpanded: [],
        withholdingTaxOnCompensationSub: [],
        withholdingTaxOnCompensation: [],
      }
    },
    methods: {
      loadList() {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .get(`/api/v1/account/withHoldingTaxAccountResult?companyId=${this.$route.query.companyId}&endDate=${this.date}`)
            .then(response => {
              this.сreditableWithHoldingTaxSub = response.data.data.сreditableWithHoldingTaxSub
              this.сreditableWithHoldingTax = response.data.data.сreditableWithHoldingTax
              this.withholdingTaxExpandedSub = response.data.data.withholdingTaxExpandedSub
              this.withholdingTaxExpanded = response.data.data.withholdingTaxExpanded
              this.withholdingTaxOnCompensationSub = response.data.data.withholdingTaxOnCompensationSub
              this.withholdingTaxOnCompensation = response.data.data.withholdingTaxOnCompensation
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
      },
      tableRowClassName({row, rowIndex}) {
        return 'bg-row';
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },
    },
    watch:{
      'date': function (val) {
        this.loadList()
      }
    },
  }
</script>

<style lang="scss" scoped>
.data-hide {
  /deep/.el-table__body-wrapper {
    display: none;
  }
}
/deep/.el-table .bg-row {
  background: #f2f4f7;
}
</style>